export default {
    title: "Felmérés elküldve",
    header: "@:views.survey.submitted.title",
    message: "Köszönjük a visszajelzést.",
}